import React from "react";
import { Button } from "@material-ui/core";
import { useTranslation } from "../../langs/useTranslation";
import { StyledSubmitBtn } from "./FormBtns";
import SendRoundedIcon from "@material-ui/icons/SendRounded";

const ConfirmAndCancelBtn = props => {
  const { t } = useTranslation("common");
  const {
    styledSubmitBtnOnClick,
    cancelBtnOnClick,
    cancelBtnDisabled,
    confirmBtnDisabled,
    hideLoadingIndicator,
    showUploadBtn,
    cancelUploadBtnOnClick
  } = props;

  const handleConfirmsBtnClick = e => {
    if (!e.detail || e.detail === 1) {
      styledSubmitBtnOnClick();
    }

    return false;
  };

  return (
    <div className="MuiDialogActions-root">
      <StyledSubmitBtn
        btnColor="primary"
        type={hideLoadingIndicator ? "button" : "submit"}
        onClick={styledSubmitBtnOnClick ? handleConfirmsBtnClick : null}
        startIcon={<SendRoundedIcon />}
        btnText={t({ defaultMessage: "上传" })}
        disabled={
          hideLoadingIndicator ? confirmBtnDisabled || cancelBtnDisabled : false
        }
      />
      <Button
        onClick={cancelBtnOnClick}
        color="secondary"
        variant="contained"
        type="button"
        disabled={cancelBtnDisabled}
        style={{ marginLeft: 10 }}
      >
        {t({ defaultMessage: "返回" })}
      </Button>
      {showUploadBtn && (
        <Button
          onClick={cancelUploadBtnOnClick}
          color="secondary"
          variant="outlined"
          type="button"
          style={{ marginLeft: 10 }}
        >
          {t({ defaultMessage: "取消上传" })}
        </Button>
      )}
    </div>
  );
};

export default ConfirmAndCancelBtn;
